<template>
  <!-- <pre v-if="responseData"> testData={{ responseData.data.kolam_renang.states }}</pre> -->
  <AdminBackground v-if="kolamRenang && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/KOLAM RENANG.png"
        alt="KOLAM RENANG"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>BILANGAN PREMIS KOLAM RENANG</h2>
      <div class="kolam-image-container">
        <div class="video-container">
          <video
            autoplay
            muted
            loop
          >
            <source
              src="@/assets/kolam/kolam-vid.mp4"
              type="video/mp4"
            >
            Your browser does not support the video tag.
          </video>
          <div class="overlay-number">
            {{ kolamRenang.bilangan_premis_kolam_renang }}
          </div>
        </div>
      </div>
     
   
      <div class="chart-wrapper">
        <PieChart :chart-data="kolamData" />
        <Update />
      </div>
    </div>

    <div class="content-wrapper">
      <div class="kolam">
        <!-- First Row - Single Box -->
        <div class="kolam-container wide">
          <img
            src="@/assets/spah/box.png"
            alt="Premis Persendirian"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>
                BILANGAN PREMIS KOLAM RENANG PERSENDIRIAN 
              </h3>
              <h3>
                (Institusi/Kelab/Firma/Syarikat/Individu/Lain-Lain Organisasi)
              </h3>
              <h3>
                (Tidak Termasuk Kediaman Dan Taman Tema)
              </h3>
              <p class="num">
                {{ kolamRenang.bilangan_premis_kolam_renang_awam }}
              </p>
            </div>
          </div>
        </div>

        <!-- Second Row - Two Boxes Side by Side -->
        <div class="kolam-row">
          <div class="kolam-container">
            <img
              src="@/assets/spah/box.png"
              alt="Premis Awam"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>BILANGAN PREMIS KOLAM RENANG AWAM</h3>
                <p class="num">
                  {{ kolamRenang.bilangan_premis_kolam_renang_swasta }}
                </p>
              </div>
            </div>
          </div>

          <div class="kolam-container">
            <img
              src="@/assets/spah/box.png"
              alt="UUK Kolam Renang"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>UUK KOLAM RENANG</h3>
                <p class="num">
                  Ada ({{ kolamRenang.bilangan_uuk_ada }}) / Tiada ({{ kolamRenang.bilangan_uuk_tiada }})
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
    <PrimaryModule />
    <KejuruteraanKesihatanMenu />  
  </AdminBackground>
</template>


<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const kolamData = ref([])

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()

const kolamRenang = ref({
  kolamRenang: {
    // eslint-disable-next-line camelcase
    bilangan_premis_kolam_renang: 0,
    // eslint-disable-next-line camelcase
    bilangan_uuk_ada: 0,
    // eslint-disable-next-line camelcase
    bilangan_uuk_tiada: 0,
  },
})

const responseData = ref(null)

const displayNameMapping = {
  // eslint-disable-next-line camelcase
  bilangan_premis_kolam_renang_awam: "Kolam Renang PBT",
  // eslint-disable-next-line camelcase
  bilangan_premis_kolam_renang_swasta: "Kolam Renang Persendirian",

}

function filterSpecificData(data) {
  const categoriesToDisplay = ['bilangan_premis_kolam_renang_awam', 'bilangan_premis_kolam_renang_swasta']
  
  return Object.entries(data)
    .filter(([name]) => categoriesToDisplay.includes(name))
    .map(([name, value]) => ({ name: displayNameMapping[name], value }))
}

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `kejuruteraan-kesihatan-umum/kolam-renang?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years


   states.value = ["Semua Negeri"] // Reset with default option
const stateList = response.data?.kolam_renang?.states
if (stateList && typeof stateList === 'object') {
  states.value.push(...Object.values(stateList))
} else {
  console.warn("Expected states at response.data.kolam_renang.states, but got:", stateList)
}


    console.log("Response States:", response.states)




    councils.value = response.councils
    responseData.value = response

    kolamRenang.value = response.data.kolam_renang.data
    kolamRenang.value.kolamRenang = {
      // eslint-disable-next-line camelcase
      bilangan_premis_kolam_renang: kolamRenang.value ? kolamRenang.value.bilangan_premis_kolam_renang : 0,
      // eslint-disable-next-line camelcase
      bilangan_uuk_ada: kolamRenang.value.bilangan_uuk_ada,
      // eslint-disable-next-line camelcase
      bilangan_uuk_tiada: kolamRenang.value.bilangan_uuk_tiada,
    }

   
    kolamData.value = filterSpecificData(kolamRenang.value)

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

}

onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}



.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #150069;
  z-index: 1;
  width: 100%;
}

.value {
  font-size: 96px;
  font-weight: 600;
  color: #150069;
}

.kolam {
  display: flex;
  flex-direction: column;
  grid-gap: 20px;
  margin-top: 20px;
}

.kolam-container.wide {
  width: 70%; /* Reduce width to make the first box smaller */
  margin: 0 auto; /* Center the container */
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

/* Second Row (Two boxes side by side) */
.kolam-row {
  display: flex;
  justify-content: space-between; /* Side by side layout */
  gap: 20px;
}

.kolam-container {
  width: 48%; /* Two boxes should take half of the available width */
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.video-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
}

.video-container video {
  width: 100%;
  height: auto;
}

.chart-wrapper {
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1200px;
}

.overlay-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 76px;
  font-weight: 600;
  color: #150069;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px 20px;
  border-radius: 10px;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.num {
  font-size: 25px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.overlay-text {
  position: absolute;
  top: 80%; 
  left: 50%; 
  transform: translate(-50%, -50%); /* Adjust positioning to ensure perfect centering */
  color: #150069;
  font-size: 54px;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}


/* Responsive Styles for 1024px */
@media (max-width: 1024px) {
  .content-wrapper {
    padding: 18px;
  }

  h2 {
    font-size: 1.4rem;
  }

  .overlay-number {
    font-size: 60px;
  }

  .kolam-container.wide {
    width: 80%;
  }
}

/* Responsive Styles for 768px */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  h2 {
    font-size: 1.2rem;
    text-align: center;
  }

  .kolam-container.wide {
    width: 90%;
  }

  .kolam-row {
    flex-direction: column;
  }

  .values-layered h3 {
    font-size: 18px;
  }

  .num {
    font-size: 22px;
  }

  .overlay-number {
    font-size: 50px;
  }
}

/* Responsive Styles for 480px */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1rem;
    text-align: left;
  }

  .kolam {
    gap: 10px;
  }

  .kolam-container.wide {
    width: 100%;
  }

  .values-layered h3 {
    font-size: 10px;
  }

  .num {
    font-size: 10px;
  }

  .overlay-number {
    font-size: 20px;
  }
}
</style>
